import styled from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 22px;
`;

export const Label = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  margin-bottom: 9px;
`;

export const Options = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 11px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const Option = styled.button<{ $selected: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  padding: 12px 14px;
  border-radius: 5px;
  background-color: ${({ theme, $selected }) =>
    $selected
      ? `color-mix(in srgb, ${theme.colors.primary.primaryLightContainer}, ${theme.colors.surface.surface})`
      : theme.colors.surface.surface};
  border: 1.5px solid
    ${({ theme, $selected }) =>
      $selected ? theme.colors.primary.primary : theme.colors.surface.surfaceOutline};

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const Radio = styled.span<{ $selected: boolean }>`
  width: 15px;
  height: 15px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 1px;
  border: ${({ $selected }) => ($selected ? '5px' : '1.5px')} solid
    ${({ theme, $selected }) =>
      $selected
        ? theme.colors.primary.primary
        : theme.colors.surface.onSurfacePlaceholder};
`;

export const OptionText = styled.span`
  display: block;
`;

export const OptionTitle = styled.strong`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.surface.onSurface};
`;

export const OptionDescription = styled.span`
  display: block;
  margin-top: 2px;
  font-size: 11.5px;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;

export const Hint = styled.div`
  font-size: 12px;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
`;
